import { render, staticRenderFns } from "./ElementForm.vue?vue&type=template&id=219d67fe&scoped=true&"
import script from "./ElementForm.vue?vue&type=script&lang=js&"
export * from "./ElementForm.vue?vue&type=script&lang=js&"
import style0 from "./ElementForm.vue?vue&type=style&index=0&id=219d67fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219d67fe",
  null
  
)

export default component.exports